import { BybSwitch } from "@Components/common/byb-ds";
import { BybSwitchFormControlLabelProps, IBybSwitch } from "@Components/common/byb-ds/toggles/byb-switch";
import { Card } from "@mui/material";

const SettingsSwitch = (props: IBybSwitch) => {
  const formControlLabelProps: BybSwitchFormControlLabelProps = {
    labelPlacement: "start",
    sx: { justifyContent: "space-between", width: "100%", m: 0 },
  };

  return (
    <Card sx={theme => ({ padding: theme.spacing(2.25, 2.5) })}>
      <BybSwitch {...props} formControlLabelProps={formControlLabelProps} />
    </Card>
  );
};

export default SettingsSwitch;
